import React from 'react';
import { TextField, type TextFieldProps } from '@mui/material';
import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

type AutocompleteInputProps = Omit<TextFieldProps, 'slotProps'> & {
  params: AutocompleteRenderInputParams;
};

/**
 * The input an `@mui/material` Autocomplete renders. Its `renderInput` params carry the popup anchor
 * (`slotProps.input.ref`) among the other slot props, so they are spread onto the TextField whole and the
 * caller's own props layered on top.
 */
const AutocompleteInput: React.FC<AutocompleteInputProps> = ({ params, ...textFieldProps }) => (
  <TextField {...params} {...textFieldProps} />
);

export default AutocompleteInput;
